import { render, staticRenderFns } from "./modal-spoiler.vue?vue&type=template&id=7136dbde&scoped=true&"
import script from "./modal-spoiler.vue?vue&type=script&lang=js&"
export * from "./modal-spoiler.vue?vue&type=script&lang=js&"
import style0 from "./modal-spoiler.vue?vue&type=style&index=0&id=7136dbde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136dbde",
  null
  
)

export default component.exports